exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-select-image__lbl[data-v-26199518] {\n    text-align: center;\n    width: 100%;\n}\n.vue-select-image__item[data-v-26199518]{\n  margin:0 15px 15px;\n}\n", ""]);

// exports
